<script setup>
import {ref, computed} from "vue";

const props = defineProps({
  logoUrl: {
    type: String,
    required: true,
  },
  directoryName: {
    type: String,
    required: true,
  },
  url: {
    type: String,
    default: null,
  },
  showLinkIcon: {
    type: Boolean,
    default: false,
  }
})

const iconMissing = ref(false);
const hasUrl = computed(() => !!props.url);
const tooltipContent = computed(() =>
  hasUrl.value
    ? 'View citation'
    : 'Some platforms use your data but don\'t offer public pages to view citations.'
);
</script>

<template>
  <div class="tw-border tw-border-neutral-300 tw-rounded-lg tw-p-6 tw-flex tw-gap-4 tw-items-center">
    <img
      v-if="!iconMissing"
      :src="logoUrl"
      :alt="directoryName"
      class="tw-shrink-0 tw-w-16 tw-h-auto"
      @error="() => {iconMissing = true}"
    >

    <svg-vue
      v-else
      icon="icons/uberall-placeholder"
      class="tw-shrink-0 tw-w-16 tw-h-auto"
    />

    <div class="tw-flex tw-flex-col tw-gap-3 tw-flex-1">
      <span class="tw-text-base tw-font-bold tw-text-neutral-900">{{ directoryName }}</span>

      <slot />
    </div>

    <a
      v-if="showLinkIcon"
      v-tooltip="{
        content: tooltipContent,
        placement: 'left',
        theme: 'dark-blue-tooltip',
      }"
      :href="url"
      target="_blank"
      rel="noopener noreferrer"
      :class="{
        'tw-text-primary hover:tw-text-primary-dark tw-transition-colors tw-shrink-0' : hasUrl,
        'tw-text-neutral-400 tw-cursor-not-allowed tw-shrink-0' :!hasUrl
      }"
    >
      <svg-vue
        icon="icons/external-thin"
        class="tw-w-5 tw-h-5"
      />
    </a>
  </div>
</template>
